export const AnimationTypewriter = () => {
  const targets = document.querySelectorAll('[data-animation="typewriter"]');
  if (!targets.length) return;

  // 初期状態でtargetsを透明にする
  targets.forEach(target => {
    target.style.opacity = '0'; // 透明に設定
    target.dataset.animated = 'false'; // アニメーション未完了を示すフラグを追加
  });

  const firstTarget = targets[0];
  const grandparent = firstTarget.parentElement?.parentElement;

  if (!grandparent) return;

  const innerTargets = grandparent.querySelectorAll('[data-animation="typewriter"]');

  // 1秒後にアニメーションを開始
  setTimeout(() => {
    observeElements(Array.from(innerTargets)); // IntersectionObserverで監視
  }, 1000);
};

// 各要素に順番にタイプライターアニメーションを適用するPromise関数
const applyTypewriterSequentially = (elements) => {
  return elements.reduce((promise, element) => {
    return promise.then(() => {
      return new Promise((resolve) => {
        // 既にアニメーション済みならスキップ
        if (element.dataset.animated === 'true') {
          return resolve();
        }

        const text = element.textContent.trim();
        element.textContent = '';

        text.split('').forEach(char => {
          const span = document.createElement('span');
          span.textContent = char;
          span.style.opacity = '0';
          span.style.display = 'inline-block';
          span.style.transition = 'opacity 0.3s';
          element.appendChild(span);
        });

        element.style.opacity = '1';

        const spans = element.querySelectorAll('span');
        spans.forEach((span, index) => {
          setTimeout(() => {
            span.style.opacity = '1';
          }, index * 80);
        });

        // アニメーション完了後にフラグを更新
        setTimeout(() => {
          element.dataset.animated = 'true';
          resolve();
        }, text.length * 100 + 200);
      });
    });
  }, Promise.resolve());
};

// IntersectionObserverで要素の可視性を監視
const observeElements = (elements) => {
  let animationInProgress = false;

  const observer = new IntersectionObserver((entries) => {
    const visibleElements = [];

    entries.forEach(entry => {
      const element = entry.target;
      if (entry.isIntersecting) {
        // 可視状態になり、アニメーション未完了の要素をリストに追加
        if (element.dataset.animated !== 'true') {
          visibleElements.push(element);
        }
      }
    });

    // アニメーションが実行中でない場合にのみ順番にアニメーションを開始
    if (visibleElements.length > 0 && !animationInProgress) {
      animationInProgress = true;
      applyTypewriterSequentially(visibleElements).then(() => {
        animationInProgress = false; // アニメーション完了後にフラグをリセット
      });
    }
  });

  elements.forEach(element => observer.observe(element));
};

